module.exports = __webpack_public_path__ + "files/fcb13f9687a09b40d1884ca8da80c721.png";